/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_5_QInputs */

const en_mk_tut_tr_5_q = /** @type {(inputs: Mk_Tut_Tr_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My colleague cannot see the channel I mean.`)
};

const id_mk_tut_tr_5_q = /** @type {(inputs: Mk_Tut_Tr_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekan saya tidak melihat channel yang saya maksud.`)
};

/**
* | output |
* | --- |
* | "My colleague cannot see the channel I mean." |
*
* @param {Mk_Tut_Tr_5_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_5_q = /** @type {((inputs?: Mk_Tut_Tr_5_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_5_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_5_q(inputs)
	return en_mk_tut_tr_5_q(inputs)
});